import { RootState } from "@/app/stores"

export const selectOnboardingOrganization = (state: RootState) => state.onboarding.organization
export const selectOnboardingContact = (state: RootState) => state.onboarding.contact
export const selectOnboardingLoading = (state: RootState) => state.onboarding.isLoading
export const selectOnboardingError = (state: RootState) => state.onboarding.error
export const selectOnboardingVerificationStatus = (state: RootState) => state.onboarding.organization?.verification_status

